var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.678 11.8938C7.9832 15.7902 2.67375 17.8883 1.81739 16.6038C0.961024 15.3192 4.85747 11.1659 10.5095 7.2694C16.1615 3.41577 21.4709 1.31768 22.3273 2.60223C23.2264 3.88677 19.33 8.04013 13.678 11.8938V11.8938Z",
    fill: "url(#paint0_linear_1_306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.592 11.8084C8.49662 15.2767 3.70099 17.1607 2.93026 16.0474C2.15953 14.8913 5.67062 11.1233 10.766 7.65508C15.8613 4.18681 20.6141 2.26 21.4277 3.41609C22.1984 4.57218 18.6873 8.34017 13.592 11.8084Z",
    fill: "url(#paint1_linear_1_306)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3432 3.37262C21.3717 3.37262 21.4003 3.38689 21.4288 3.41544C22.1996 4.57153 18.6885 8.33952 13.5931 11.8078C8.49775 15.2761 3.70212 17.1601 2.93139 16.0468C2.93139 16.0182 2.91713 15.9897 2.88858 15.9611C3.83058 16.9888 8.49776 15.1048 13.5075 11.6793C18.5172 8.25389 21.9855 4.57153 21.3432 3.37262Z",
    fill: "#A86314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65287 6.0275C15.3049 2.13106 20.6143 0.0329648 21.4707 1.31751L22.327 2.60205C21.4707 1.31751 16.1612 3.4156 10.5092 7.26923C4.85724 11.1657 0.960789 15.319 1.81715 16.6036L0.960789 15.319C0.0616084 14.0345 3.95806 9.88114 9.65287 6.0275V6.0275Z",
    fill: "url(#paint2_linear_1_306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_306",
    x1: 21.5565,
    y1: 0.375684,
    x2: 24.5966,
    y2: 4.87159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_306",
    x1: 19.5437,
    y1: -1.037,
    x2: 23.954,
    y2: 6.15645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_306",
    x1: -1.30857,
    y1: 12.3646,
    x2: 20.2718,
    y2: -2.36485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin7);
export default __webpack_public_path__ + "static/media/coin7.5b3c8bd7ab421f4b1367f1104334fdb1.svg";
export { ForwardRef as ReactComponent };